var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer d-flex p-2 px-3 bg-white border-top"},[_c('div',{class:[_vm.contained ? 'container' : 'container-fluid', 'h-100']},[_c('div',{staticClass:"text-center py-2"},[_c('span',{staticClass:"copyright my-auto"},[_vm._v(_vm._s(_vm.copyright))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }